import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const userService = {
  // Get all users
  getAll: async () => {
    const response = await api.get(API_ENDPOINTS.USERS);
    return response.data;
  },

  // Get single user
  getById: async (id) => {
    const response = await api.get(API_ENDPOINTS.USER_DETAIL(id));
    return response.data;
  },

  // Update user
  update: async (id, data) => {
    const response = await api.put(API_ENDPOINTS.USER_DETAIL(id), data);
    return response.data;
  },

  // Delete user
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.USER_DETAIL(id));
    return response.data;
  },
};